import type { ReactNode } from 'react'

import cn from '@components/utils/cn'
import Icon, { type IconTypes } from '@components/utils/Icon'

/** The card shell every import page shares, so the importers read as one surface. */
export function Card({ children, className, id }: { children: ReactNode; className?: string; id?: string }) {
  return (
    <section id={id} className={cn('tw:rounded-xl tw:border tw:border-gray-200 tw:bg-white tw:shadow-xs', className)}>
      {children}
    </section>
  )
}

export function CardHeading({
  icon,
  title,
  subtitle,
  actions,
}: {
  icon: IconTypes
  title: string
  subtitle?: ReactNode
  actions?: ReactNode
}) {
  return (
    <div className="tw:flex tw:flex-wrap tw:items-center tw:gap-3 tw:border-b tw:border-gray-200 tw:px-5 tw:py-4">
      <span
        aria-hidden
        className="tw:flex tw:h-8 tw:w-8 tw:shrink-0 tw:items-center tw:justify-center tw:rounded-lg tw:bg-primary-50 tw:text-primary-600"
      >
        <Icon type={icon} className="tw:h-4 tw:w-4" />
      </span>
      <div className="tw:min-w-0 tw:flex-1">
        <h2 className="tw:m-0 tw:text-base tw:font-bold tw:text-gray-cool-900">{title}</h2>
        {subtitle && <p className="tw:mb-0 tw:mt-0.5 tw:text-sm tw:text-gray-cool-600">{subtitle}</p>}
      </div>
      {actions && <div className="tw:flex tw:shrink-0 tw:items-center tw:gap-2">{actions}</div>}
    </div>
  )
}
